import React, { Component, Fragment } from 'react';
import * as input from '../connectedForm/inputComponents';
import { default as Form } from '../connectedForm';
import ColumnLabel from '../connectedForm/ColumnLabel/ColumnLabel';

class Units extends Component {
  constructor(props) {
    super(props);
    this.renderAlternateUnit = this.renderAlternateUnit.bind(this);
  }

  render() {
    if (!this.props.units) return null;
    return (
      <Form.Fieldset cols={1 / 2} collapsed={true}>
        <Form.Legend label="Units" />
        <Form.Row>
          <Form.Fieldset cols={1 / 6} collapsed={true}>
            <ColumnLabel label="Description" />
          </Form.Fieldset>
          <Form.Fieldset cols={1 / 6} collapsed={true}>
            <ColumnLabel label="Quantity" />
          </Form.Fieldset>
          <Form.Fieldset cols={1 / 6} collapsed={true}>
            <ColumnLabel label="Unit Price" />
          </Form.Fieldset>
          <Form.Fieldset cols={1 / 6} collapsed={true}>
            <ColumnLabel label="Barcode" />
          </Form.Fieldset>
        </Form.Row>
        {this.renderAlternateUnit(0)}
        {this.renderAlternateUnit(1)}
        {this.renderAlternateUnit(2)}
        {this.renderAlternateUnit(3)}
        {this.renderAlternateUnit(4)}
        {this.renderAlternateUnit(5)}
        {this.renderAlternateUnit(6)}
        {this.renderAlternateUnit(7)}
        {this.renderAlternateUnit(8)}
        {this.renderAlternateUnit(9)}
        {this.renderAlternateUnit(10)}
      </Form.Fieldset>
    );
  }

  renderAlternateUnit = (unitIndex) => {
    let altUnit = this.props.units[unitIndex];
    if (altUnit == null) return null;

    let baseUnit = this.props.units[0];

    let conversionDescription = altUnit.quantityFactor;

    if (unitIndex == 0) {
      conversionDescription += ' ' + baseUnit.description;
    } else if (altUnit.factorDirection == 'FROM_BASE_UNIT') {
      conversionDescription += ` ${baseUnit.description}(s) per ${altUnit.description}`;
    } else {
      conversionDescription += ` ${altUnit.description}(s) per ${baseUnit.description}`;
    }

    return (
      <Form.Row>
        <Form.Fieldset cols={1 / 6} collapsed={true}>
          <Form.Field
            component={input.BlurTextField}
            includeLabel={false}
            inputCols={1}
            readOnly={true}
            value={altUnit.description}
          />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 6} collapsed={true}>
          <Form.Field
            value={conversionDescription}
            component={input.BlurTextField}
            includeLabel={false}
            readOnly={true}
            inputCols={1}
          />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 6} collapsed={true}>
          <Form.Field
            value={altUnit.grossSellingPrice}
            component={input.BlurTextField}
            includeLabel={false}
            readOnly={true}
            inputCols={1}
          />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 6} collapsed={true}>
          <Form.Field
            value={altUnit.barcode}
            component={input.BlurTextField}
            includeLabel={false}
            readOnly={true}
            inputCols={1}
          />
        </Form.Fieldset>
      </Form.Row>
    );
  };
}

export default Units;
